import { SneakLaunch } from '~/services/sneaker-release/sneaker-release.type';
import ProductItemLaunch from './Item';

type ProductLaunchProps = {
    products?: SneakLaunch[];
    loading?: boolean;
};

const ProductLaunch = ({ products, loading }: ProductLaunchProps) => {
    return (
        <section className="grid grid-cols-12 gap-4 md:gap-6 mx-auto md:gap-y-4 w-full">
            <div className="col-span-full grid grid-cols-12 gap-4 md:gap-6">
                {products?.map((product, index) => {
                    return <ProductItemLaunch key={index} product={product} loading={loading} />;
                })}
            </div>
        </section>
    );
};

export default ProductLaunch;
